import { Helmet } from "react-helmet-async"
import { SupplierList } from "../../../Supplier"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"

export default function HotelSuppliersPage() {
	return (
		<ForbidUnlessAuthorized permission={PERMISSIONS.VIEW_HOTEL_SUPPLIERS}>
			<Helmet>
				<title>Hotel Suppliers</title>
			</Helmet>
			<SupplierList title="Hotel Suppliers" supplierType="hotels" />
		</ForbidUnlessAuthorized>
	)
}
